import React from 'react'
import PropTypes from 'prop-types'
import Dialog from '@material-ui/core/Dialog'
import Slide from '@material-ui/core/Slide'
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';
import bookingSourceImages from '../../GuestPortal/images';
import bookingSourceColors from '../../GuestPortal/colors';
import getTextContrastColor from '../../../libs/textContrastColor';

const useStyles = backgroundColor => makeStyles(theme => ({
    dialog: {
        backgroundColor: backgroundColor,
        textAlign: 'center',
        position: 'relative',
    },
    root: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        color: getTextContrastColor(backgroundColor),
        width: '100%',
    },
    logo: {
        maxWidth: '80%',
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(4),
    },
    largeText: {
        fontSize: 'xx-large'
    },
    xlargeText: {
        fontSize: 'xxx-large'
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const KioskOverlay = ({open, branding, onClose}) => {
    const logoSource = bookingSourceImages(branding, 1);
    const backgroundColor = bookingSourceColors(branding);
    const classes = useStyles(backgroundColor)();
    return (
        <Dialog
            open={open}
            onClose={onClose}
            TransitionComponent={Transition}
            classes={{paper: classes.dialog}}
            PaperProps={{onClick: onClose}}
            fullScreen
        >
            <div className={classes.root}>
                <Typography
                    variant="h3"
                    color="inherit"
                    className={classes.largeText}
                    gutterBottom
                >
                    Welcome to
                </Typography>

                {logoSource && <img src={logoSource} className={classes.logo}/>}
                {!logoSource &&
                <Typography
                    variant="h1"
                    color="inherit"
                    className={classes.xlargeText}
                    gutterBottom
                >
                    {branding.company.name}
                </Typography>
                }

                <Typography
                    variant="h4"
                    color="inherit"
                    gutterBottom
                >
                    Touch anywhere to begin
                </Typography>
            </div>
        </Dialog>
    )
}

KioskOverlay.propTypes = {
    open: PropTypes.bool.isRequired,
    branding: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default KioskOverlay